module.exports = __webpack_public_path__ + "static/img/acq-form-3.19af472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/acq-form-3.png
// module id = 6IkK
// module chunks = 1